import { initializeIcons } from "@fluentui/react";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./Global.css";
import reportWebVitals from "./reportWebVitals";

initializeIcons();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
